import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import cs from 'classnames';

import { CardActions } from 'constants/enums';

import styles from './SelectCardWrapper.module.scss';
import { cardActionsConfig } from './cardActionsConfig';

interface CardActionLabelProps {
  action: CardActions;
  isDisabled?: boolean;
}

const CardActionLabel: FC<CardActionLabelProps> = ({
  action,
  isDisabled
}: CardActionLabelProps) => {
  const { t } = useTranslation();
  const config = cardActionsConfig.find((el) => el.value === action);
  if (!config) return null;

  return (
    <div
      className={cs(styles.actionLabel, config.className, {
        [styles.disabled]: isDisabled
      })}
    >
      {config.icon}
      {t(config.label)}
    </div>
  );
};

export default CardActionLabel;
